// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PencilRulerIconSignature {
  Element: SVGSVGElement;
}

export const PencilRulerIcon: TOC<PencilRulerIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 1H13C11.897 1 11 1.898 11 3V21C11 22.103 11.897 23 13 23H19C20.103 23 21 22.103 21 21V3C21 1.898 20.103 1 19 1ZM13 21V18H16V16H13V13H16V11H13V8H16V6H13V3H19L19.001 21H13ZM3 7C3 5.346 4.346 4 6 4C7.654 4 9 5.346 9 7V18.303L6 22.803L3 18.303V7ZM6 19.197L7 17.697V10H5V17.697L6 19.197ZM5 8V7C5 6.448 5.449 6 6 6C6.551 6 7 6.448 7 7V8H5Z"/>
</svg>
</template>;